<template>
    <div class="sw-column"
         :id="'sw-' + component.component + '-' + id">
        <JetLabel v-if="component.attributes.label" class="sw-mb-1 sw-mt-1" :value="component.attributes.label"></JetLabel>
        <JetLabel v-if="title"
                  :class="['sw-mt-1 d-block', formType === 'costsIndicator' ? 'sw-mb-1' : 'sw-mb-2']"
                  :value="title"
                  formType="costsIndicator"
        />
        <input @change="handleChange($event)"
               v-bind="component.attributes"
               :required="requiredInput"
               :type=inputType()
               :class="['sw-input', { required: requiredInput }]"
        />
    </div>
</template>

<script>
import JetLabel from '@/Jetstream/Label.vue'
export default {
    name: "Input",
    components:{
        JetLabel
    },
    props:{
        edit:Boolean,
        formType: String,
        title: String,
        id: String,
        component: {
            type:Object,
            required:true
        }
    },
    computed: {
        requiredInput: {
            get(){
                return this.component.attributes.required === '1' || this.component.attributes.required === true;
            },
            set(value) {
                this.component.attributes.required = value;
            }
        }
    },
    methods: {
        handleChange(event) {
            const payload = { id: this.component.id, value: event.target.value };
            if (this.formType === "costsIndicator") {
                this.$emit('input:checked', payload);
            } else {
                this.$emit('updateContact', payload);
            }
        },
        inputType() {
            if (!this.component.settings) {
                return undefined;
            }
            if (this.component.settings.isDate) {
                return 'date';
            }
            if (this.component.settings.isNumber) {
                return 'number';
            }
            return undefined;
        }
    }
}
</script>

<style scoped lang="sass">
    .d-block
        display: block
</style>
